import { Mascot } from "../components/Mascot";

type PricingBottomCTAProps = {
  getStartedHref: string;
};

export function PricingBottomCTA({ getStartedHref }: PricingBottomCTAProps) {
  return (
    <section className="px-[clamp(16px,3vw,40px)] pb-16">
      <div className="bottom-cta-card relative mx-auto max-w-[1240px] overflow-hidden rounded-[32px] bg-[radial-gradient(ellipse_at_50%_50%,#4F46E5_0%,#6366F1_45%,#818CF8_100%)] px-[clamp(40px,6vw,96px)] py-[clamp(56px,7vw,88px)] text-center shadow-[0_40px_80px_-30px_rgba(67,56,202,0.5)]">
        <div className="absolute -bottom-5 -left-8 rotate-[-10deg] opacity-95 [filter:drop-shadow(0_12px_24px_rgba(0,0,0,0.3))]">
          <Mascot name="Quill" size={150} full />
        </div>
        <div className="absolute -top-2 -right-8 rotate-[10deg] opacity-95 [filter:drop-shadow(0_12px_24px_rgba(0,0,0,0.3))]">
          <Mascot name="Sage" size={150} full />
        </div>

        <div className="relative z-[2]">
          <h2 className="font-companion mb-4 text-[clamp(32px,4.6vw,52px)] font-bold leading-[1.05] tracking-[-0.03em] text-white [text-wrap:balance]">
            500 Treats on us.
          </h2>
          <p className="mx-auto mb-8 max-w-[480px] text-[17px] leading-[1.55] text-white/95 [text-wrap:pretty]">
            Get started with Companion and we&apos;ll drop 500 Treats in your
            account — no card required.
          </p>
          <div className="flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center">
            <a
              href="https://calendly.com/d/cvxs-349-5w3/companion-askcompanion-com"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex w-full items-center justify-center gap-2.5 rounded-full border border-white/45 bg-white/10 px-7 py-4 font-body text-base font-semibold text-white no-underline backdrop-blur-md transition-[background,transform] duration-150 ease-[ease] hover:-translate-y-px hover:bg-white/20 sm:w-auto"
            >
              Book a demo
            </a>
            <a
              href={getStartedHref}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex w-full items-center justify-center gap-2.5 rounded-full border-0 bg-white px-7 py-4 font-body text-base font-semibold text-[#4338CA] no-underline shadow-[0_12px_32px_-8px_rgba(49,46,129,0.35)] transition-[transform,box-shadow] duration-150 ease-[ease] hover:-translate-y-px hover:shadow-[0_18px_40px_-8px_rgba(49,46,129,0.45)] sm:w-auto"
            >
              Get started
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path
                  d="M5 12h14M13 5l7 7-7 7"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
